'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeader = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var CardHeader = exports.CardHeader = _styledComponents2.default.div(_templateObject, _styledSystem.space, _styledSystem.width, _styledSystem.color, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.textAlign, _styledSystem.lineHeight, _styledSystem.display, _styledSystem.borderRadius, _styledSystem.borderColor, _styledSystem.borders);